module.exports = __webpack_public_path__ + "img/solar_house_pattaya.f3aff3d8.svg";